import { transform } from 'ol/proj';
import arc from 'arc';
export class Utils {
    static transformCoords([lat, long]) {
        const parsedLat = typeof lat === 'string' ? parseFloat(lat) : lat;
        const parsedLong = typeof long === 'string' ? parseFloat(long) : long;
        return transform([parsedLong, parsedLat], 'EPSG:4326', 'EPSG:3857');
    }
    static degreesToRadians(angle) {
        return angle * (Math.PI / 180);
    }
    // get bearing/heading angle of device/car in EPSG:3857 in radians
    static getAngleOfRotationMercator(sourceLat, sourceLon, destinationLat, destinationLon) {
        // (x,y) = Lon, lat
        // coordinate = [Lon, Lat]
        // transform coordinates to EPSG:3857
        const dx = destinationLat - sourceLat;
        const dy = destinationLon - sourceLon;
        return Math.atan2(dx, dy);
    }
    static getCirclePoints(coordsDep, coordsArr) {
        const arcGenerator = new arc.GreatCircle({ x: coordsDep[1], y: coordsDep[0] }, { x: coordsArr[1], y: coordsArr[0] });
        const arcLine = arcGenerator.Arc(100, { offset: 10 });
        return arcLine.geometries[0].coords;
    }
}
